/** Mansion ecosystem SEO — CheepSweepz (cheepsweepz.shop) */

export const CHEEP_SEO = {
  siteName: "CheepSweepz Concierge",
  siteUrl: "https://cheepsweepz.shop",
  defaultTitle: "CheepSweepz | Global Cross-Country Import Concierge",
  defaultDescription:
    "Import from Japan, UK, Australia, US, Canada & China to the Caribbean and worldwide. FedEx + DHL cross-country shipping, customs cleared, one transparent landed price. Shop Amazon, eBay, AliExpress & more.",
  keywords:
    "cross-country shipping, global import, FedEx DHL concierge, Japan to Barbados, UK import, landed cost, customs included, Amazon import, CheepSweepz, Caribbean delivery, premium import",
  globalShippingTitle: "Global Cross-Country Shipping | CheepSweepz Concierge",
  globalShippingDescription:
    "Premium global courier lanes from Japan, UK, Australia, US, Canada, China and more. Live door-to-door quotes with customs brokerage and clearance included in one price.",
};

export const CONCIERGE_TIERS = [
  {
    id: "premium_import",
    label: "White-Glove Global",
    badge: "Premium",
    description: "Priority handling for high-value international imports.",
  },
  {
    id: "standard",
    label: "Concierge Standard",
    badge: "Essential",
    description: "Reliable door-to-door clearance for everyday global orders.",
  },
  {
    id: "sovereign_trade",
    label: "Sovereign Partner",
    badge: "B2B",
    description: "Dedicated partner lane for verified volume merchants.",
  },
];
